<template>
  <div class="page-container">
    <!--内容-->
    <div class="container pt-200">
      <!--面包屑导航-->
      <Breadcrumb :breadcrumbList="[type]"></Breadcrumb>
      <div class="noticecon">
        <div class="tip bg-colfa flex ai-center">
          <span class="fontcol4 fs-24 ml-35">{{ type }}</span>
          <span class="fontcol6 fs-28 fstyle-italic">{{
            type == "新闻"
              ? "/News"
              : type == "公告"
              ? "/Announcement"
              :type=="领导关怀"
              ? "/LeadershipCare"
              : "/Talent recruitment"
          }}</span>
        </div>
        <div class="notice flex jc-center flex-w">
          <div class="title fs-24 color-fontcol4 mt-40 text-center">
            {{ listdetail.title }}
          </div>
          <div class="msg mt-30 flex ai-center jc-center">
            <!-- <img class="icon" src="../assets/image/user.png" alt="" />
            <span class="color-fontcol8 fs-12 ml-10">作者：{{ listdetail.author }}</span>
            <img class="icon ml-40" src="../assets/image/source.png" alt="" />
            <span class="color-fontcol8 fs-12 ml-10">来源：{{ listdetail.source }}</span> -->
            <img class="icon ml-40" src="../assets/image/time.png" alt="" />
            <span class="color-fontcol8 fs-12 ml-10 mr-35">日期：{{ listdetail.time }}</span>
          </div>
          <div class="detail mt-30">
            <div
              class="detailcontent color-fontcol3 fs-16"
              style="text-indent: 2em"
              v-html="listdetail.content"
            ></div>
            <!-- <img
              class="detailimg mt-40"
              :src="'http://www.cctpress.com/file/' + listdetail.cover"
              alt=""
            /> -->
            <div class="unline mt-45"></div>
            <div class="otherdetail pt-20 pb-40" v-if="partTwoList.length">
              <li
                class="fs-16 mt-20 point"
                v-for="(item, index) in partTwoList"
                :key="index"
                @click="getdetail(item.id)"
                @mouseenter="mousepart(index)"
                :class="chosepart == index ? 'color-fontactive' : 'color-fontcol8'"
              >
                <span class="mr-10">{{
                  index == 0 && item.title
                    ? "上一篇"
                    : index == 1 && item.title
                    ? "下一篇"
                    : ""
                }}</span
                >{{ item.title }}
              </li>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Breadcrumb from "../components/common/breadcrumb";
import { replaceImg } from "../assets/js/replaceImg";
export default {
  name: "noticedetail",
  components: {
    Breadcrumb,
  },
  data() {
    return {
      id: "", //新闻id
      type: "", //新闻/公告/招聘
      detailname: "", //招聘详情标题
      listdetail: "", //列表详情
      partTwoList: [],
      chosepart: 0, //是否选择上下篇
    };
  },
  mounted() {
    this.detailname = this.$route.query.name;
    this.id = this.$route.query.id;
    var type = this.$route.query.type;
    if (type == 1) {
      this.type = "新闻";
    } else if (type == 2) {
      this.type = "公告";
    } else if (type == 3)  {
      this.type = "领导关怀";
    }else{
      this.type = "人才招聘";
    }
    this.getdetail(this.id);
  },
  methods: {
    async getdetail(id) {
      var res = await this.$API.API_Ajax("新闻公告详情", {
        contentId: id,
      });
      if (res.code == 200) {
        var list = res.data;
        list.time = this.$moment(new Date(list.createTime.time).getTime()).format(
          "YYYY-MM-DD"
        );
        list.content = replaceImg({
          str: list.content,
          width: 300,
          height: 100,
        });
        this.listdetail = list;
        if (res.data.preContent || res.data.nextContent) {
          if (!res.data.preContent) {
            this.partTwoList[0] = [];
            this.partTwoList[1] = res.data.nextContent;
          } else if (!res.data.nextContent) {
            this.partTwoList[0] = res.data.preContent;
            this.partTwoList[1] = [];
          } else {
            this.partTwoList[0] = res.data.preContent;
            this.partTwoList[1] = res.data.nextContent;
          }
        }
      }
    },
    //是否选择上下篇
    mousepart(index) {
      this.chosepart = index;
    },
  },
};
</script>
<style lang="scss" scoped>
.page-container {
  width: 100%;
  height: auto;
  margin: auto;
  .noticecon {
    width: 68%;
    margin: auto;
    margin-top: 80px;
    margin-bottom: 100px;
    border: 1px solid #e8e8e8;
    .tip {
      width: 100%;
      height: 70px;
      border: 1px solid #ededed;
    }
    .notice {
      width: 1191px;
      margin: auto;
      .title {
        width: 100%;
      }
      .msg {
        width:100%;
        .icon {
          width: 13px;
          height: 13px;
        }
      }
      .detail {
        width: 100%;
        .detailimg {
          width: 100%;
          height: 245px;
        }
        .unline {
          width: 1239px;
          height: 1px;
          background: #ededed;
          margin-left: -23px;
        }
        .otherdetail {
          width: 100%;
        }
      }
    }
  }
}
</style>
